/* Rapid Sport — colour-match product cards (mega menu + rs_new product lists).
   Samples the dominant chromatic colour from each card image and writes --rs-tint-a / --rs-tint-b. */
(function () {
  var CACHE = 'rs-tint-v1';
  var SEL = '.menu-list__submenu .mega-menu__content-list--products .resource-card, main [id$="__rs_new"] product-card';
  var store = {};
  try { store = JSON.parse(sessionStorage.getItem(CACHE) || '{}'); } catch (e) {}
  function save() { try { sessionStorage.setItem(CACHE, JSON.stringify(store)); } catch (e) {} }
  function rgbToHsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h = 0, s = 0, l = (max + min) / 2, d = max - min;
    if (d) {
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
      else if (max === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h *= 60;
    }
    return [h, s, l];
  }
  function hsl(h, s, l) { return 'hsl(' + Math.round(h) + ' ' + Math.round(s * 100) + '% ' + Math.round(l * 100) + '%)'; }
  function sample(img) {
    var N = 48, c = document.createElement('canvas');
    c.width = N; c.height = N;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, N, N);
    var d = ctx.getImageData(0, 0, N, N).data, bins = {}, best = null, bestScore = -1;
    for (var i = 0; i < d.length; i += 4) {
      if (d[i + 3] < 200) continue;
      var r = d[i], g = d[i + 1], b = d[i + 2];
      var hsl3 = rgbToHsl(r, g, b), S = hsl3[1], L = hsl3[2];
      if (L > 0.94 || L < 0.06) continue;
      if (S < 0.08 && L > 0.82) continue;
      var key = (r >> 4) + '-' + (g >> 4) + '-' + (b >> 4);
      var bin = bins[key] || (bins[key] = { n: 0, r: 0, g: 0, b: 0, s: 0 });
      bin.n++; bin.r += r; bin.g += g; bin.b += b; bin.s += S;
    }
    for (var k in bins) { var v = bins[k], score = v.n * (0.45 + v.s / v.n); if (score > bestScore) { bestScore = score; best = v; } }
    if (!best) return null;
    var h3 = rgbToHsl(best.r / best.n, best.g / best.n, best.b / best.n);
    var H = h3[0], S2 = Math.min(0.72, Math.max(0.18, h3[1]));
    var lightL = Math.min(0.58, Math.max(0.40, h3[2]));
    var darkL = Math.max(0.16, lightL - 0.22);
    return [hsl(H, S2, lightL), hsl(H, Math.min(0.85, S2 + 0.06), darkL)];
  }
  function paint(card, pair) { card.style.setProperty('--rs-tint-a', pair[0]); card.style.setProperty('--rs-tint-b', pair[1]); card.dataset.rsTinted = '1'; }
  function run(card) {
    if (card.dataset.rsTinted) return;
    var src = card.querySelector('img');
    src = src && (src.currentSrc || src.src);
    if (!src) return;
    var key = src.split('?')[0];
    if (store[key]) { paint(card, store[key]); return; }
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.decoding = 'async';
    probe.onload = function () { var pair; try { pair = sample(probe); } catch (e) { return; } if (!pair) return; store[key] = pair; save(); paint(card, pair); };
    probe.src = src;
  }
  function scan() { document.querySelectorAll(SEL).forEach(run); }
  function init() {
    scan();
    var host = document.getElementById('header-group') || document.body;
    new MutationObserver(function () { scan(); }).observe(host, { childList: true, subtree: true });
    host.addEventListener('pointerenter', scan, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', scan);
})();
